import { ProjectForSelectFragment } from 'generated/resources/graphql'

import Filter from 'modules/core/components/Filter'
import i18n from 'modules/core/lib/i18n'

import { ProjectSelector } from 'modules/project_management/components/selectors/ProjectSelector'

interface ProjectsFilterProps {
  selected: ProjectForSelectFragment[]
  setSelected: (value: ProjectForSelectFragment[]) => void
}

const ProjectsFilter = ({ selected, setSelected }: ProjectsFilterProps) => {
  return (
    <Filter.EntitySelector
      label={i18n.t('expenses_v2.reports.filters.project.label')}
      value={selected}
      nameAttribute={'name'}
      onValueChange={() => {}}
      component={() => (
        <ProjectSelector
          alwaysOpen
          hideBorder
          multiple
          value={selected}
          onChange={(projects) => {
            setSelected(projects)
          }}
          label=""
        />
      )}
    />
  )
}

export default ProjectsFilter
